import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosClient from "../../../utils/axiosClient";
import {
  urlInformacoes,
  urlAgendamentosAlterarStatus,
} from "../../../utils/constants";
import MenuSide from "../../../components/empresas/MenuSide";
import {
  IonButton,
  IonLabel,
  IonPage,
  IonContent,
  IonCard,
  IonSelect,
  IonSelectOption,
  IonItem,
  IonToast,
} from "@ionic/react";

import HeaderApp from "../../../components/global/HeaderItem";
import StatusAgendamento from "../../../components/global/StatusAgendamento";
import moment from "moment";
import "moment/locale/pt-br";
moment().locale("pt-br");

export default function AgendamentoEmpresas() {
  const [itens, setItens] = useState([]);
  const [status, setStatus] = useState("");
  const [toastSuccess, setToastSuccess] = useState(false);
  const [toastError, setToastError] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const idPage = urlParams.get("id");

  const statusArray = [
    {
      id: 1,
      nome: "Pendente",
    },
    {
      id: 2,
      nome: "Em andamento",
    },
    {
      id: 3,
      nome: "Não confirmado",
    },
    {
      id: 4,
      nome: "Finalizado",
    },
    {
      id: 5,
      nome: "Cancelado",
    },
    {
      id: 6,
      nome: "Reembolsado",
    },
  ];

  const consultaLista = async (url) => {
    try {
      const response = await axiosClient.post(url, {});
      return response.data[0];
    } catch (error) {
      console.log(error);
    }
  };
  const alterarStatus = async () => {
    try {
      const response = await axiosClient.post(urlAgendamentosAlterarStatus, {
        status: status,
        id: idPage,
      });
      if (response) {
        setToastSuccess(true);
      }
    } catch (error) {
      setToastError(true);
    }
  };

  const consultarItens = async () => {
    const pathname = location.pathname;

    const partesDoCaminho = pathname.split("/");
    const tipo = partesDoCaminho[1];
    const tela = "agendamentos";

    const url = urlInformacoes(tipo, tela, `id=${idPage}`);
    const lista = await consultaLista(url);
    setItens(lista);
    setStatus(lista.status);
  };

  useEffect(() => {
    consultarItens();
  }, []);

  function calcularDiferencaEmMinutos(horario1, horario2) {
    if (horario1 && horario2) {
      // Divida os horários em horas, minutos e segundos
      const [hora1, minuto1, segundo1] = horario1.split(":").map(Number);
      const [hora2, minuto2, segundo2] = horario2.split(":").map(Number);

      // Calcule a diferença em minutos
      const minutos1 = hora1 * 60 + minuto1 + segundo1 / 60;
      const minutos2 = hora2 * 60 + minuto2 + segundo2 / 60;

      // Calcule a diferença entre os minutos
      const diferencaEmMinutos = Math.abs(minutos2 - minutos1);

      return diferencaEmMinutos;
    }
  }

  return (
    <IonPage  id="main-content">
      <HeaderApp />
      <IonContent className="contentAgendamento">
        <IonToast
          isOpen={toastSuccess}
          color={'success'}
          icon="alert-outline"
          message="Status alterado com sucesso!"
          onDidDismiss={() => setToastSuccess(false)}
          duration={2000}
          buttons={[
            {
              text: "Ok",
              role: "info",
              handler: () => {
                navigate({ pathname: "/empresas/agendamentos" });
              },
            },
          ]}
        ></IonToast>
         <IonToast
          isOpen={toastError}
          color={'danger'}
          icon="alert-outline"
          message="Não foi possível alterar o status!"
          onDidDismiss={() => setToastError(false)}
          duration={2000}
          buttons={[
            {
              text: "Ok",
              role: "info",
              handler: () => {
               return;
              },
            },
          ]}
        ></IonToast>
      
        <br />
        <div className="ion-text-center">
          <h1 style={{ fontSize: 40 }}>
            {calcularDiferencaEmMinutos(
              itens.horario_inicial,
              itens.horario_final
            )}
            <b style={{ fontSize: 15 }}>&nbsp;min</b>
          </h1>
        </div>

        <IonCard>
          <IonLabel>
            <div className="ion-padding">
              <h2>
                <i className="ri-calendar-line"></i>&nbsp;
                {moment(itens.data_agendamento).format("D")} de{" "}
                {moment(itens.data_agendamento).format("MMMM")} de{" "}
                {moment(itens.data_agendamento).format("YYYY")}
              </h2>
              <h5 style={{ marginTop: "7px", marginBottom: "5px" }}>
                <i className="ri-time-line"></i>&nbsp;
                {moment("2023-01-01 " + itens.horario_inicial).format(
                  "HH:mm"
                )}{" "}
                / {moment("2023-01-01 " + itens.horario_final).format("HH:mm")}
              </h5>
              <h5>
                <i className="ri-store-2-line"></i>&nbsp; Serviço:{" "}
                {itens.servico}
              </h5>
              <h5>
                <i className="ri-user-3-line"></i> &nbsp; Cliente:{" "}
                {itens.cliente_nome}
              </h5>
              {itens.status && (
                <h5 style={{ marginTop: "7px", marginBottom: "5px" }}>
                  <StatusAgendamento
                    status={itens.status}
                    data={itens.data_agendamento}
                  />
                  <p style={{ marginTop: "7px", marginBottom: "5px" }}>
                    <i className="ri-information-line"></i> &nbsp; {itens.obs}
                  </p>
                </h5>
              )}
            </div>
          </IonLabel>
        </IonCard>

        <IonItem>
          <IonSelect
            mode="ios"
            aria-label="Status"
            placeholder="Clique aqui"
            onIonChange={(e) => setStatus(e.detail.value)}
            value={status}
          >
            {statusArray.map((item, index) => (
              <IonSelectOption key={index} value={item.id}>
                {item.nome}
              </IonSelectOption>
            ))}
          </IonSelect>
        </IonItem>
        <br />
        <div className="ion-margin">
          <IonButton
            color="secondary-light"
            expand="full"
            onClick={() => alterarStatus()}
          >
            Atualizar status
          </IonButton>
        </div>
      </IonContent>
      <MenuSide />
    </IonPage>
  );
}
